import { mdiAirballoonOutline } from "@mdi/js";
import Icon from "@mdi/react";
import React from "react";
import Slider from "react-slick";
import LocationsApi from "../../api-services/locations-api.service";
import { notification } from "antd";
import { Location } from "../../interfaces/country.interface";
import { Link } from "react-router-dom";

const settings = {
  dots: true,
  arrows: false,
  speed: 500,
  slidesToShow: 6,
  infinite: false,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 375,
      settings: {
        slidesToShow: 1,
      }
    },
  ],
 };

 interface IDestinationsHighlightProps {
  locationGroupCodes: string[]
 }

 export default class DestinationsHighlight extends React.Component<IDestinationsHighlightProps> {
  locationsApi = new LocationsApi;

  state = {
    countries: []
  }

  componentDidMount() {
  this.locationsApi.getLocations({group: this.props.locationGroupCodes, highlighted: true})
      .then(({locations}) => {
        this.setState({countries: locations})
      })
      .catch(error => {
        notification.error({ message: 'An error occured while loading countries.'});
      });
  }
  
  render(){
    const listingLink = (locator) => `/web/listing?keyword=${locator.name}&location_id=${locator.id}`;
    const {countries} = this.state;
    return countries.length > 0 && (
      <div id="destinations-highlight">
        <div id="destinations-highlight_body">
          <h1>
            <Icon path={mdiAirballoonOutline} size={1} />
            Destinations Highlight
          </h1>

          <div id="destinations-slider">
            <Slider {...settings}>
              {
                countries.map((country:Location) => {
                  return <Link to={listingLink(country)} key={country.id} className="destination">
                    <img src={country.cover}/>
                    <label> {country.name} </label>
                  </Link>
                })
              }
            </Slider>
          </div>
        </div>
      </div>
    )
  }
 }